/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="82.25"
        height="67.11"
        viewBox="0 0 82.25 67.11"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="M26.06 0a14.12 14.12 0 1 0 14.12 14.12A14.12 14.12 0 0 0 26.06 0Zm0 2.5a11.62 11.62 0 1 1-11.62 11.62A11.62 11.62 0 0 1 26.06 2.5ZM31.98 36.53a1.25 1.25 0 0 1 .13 2.47H13.44A10.94 10.94 0 0 0 2.5 49.68v2.1a1.25 1.25 0 0 1-2.49.13V50a13.45 13.45 0 0 1 13.12-13.47h18.85ZM59.97 22.54a22.29 22.29 0 1 0 22.28 22.29 22.29 22.29 0 0 0-22.28-22.29Zm0 2.5a19.79 19.79 0 1 1-19.79 19.79A19.79 19.79 0 0 1 59.97 25Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M59.92 33.66a1.24 1.24 0 0 1 1.24 1.12v19.84a1.25 1.25 0 0 1-2.49.12V34.91a1.25 1.25 0 0 1 1.25-1.25Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M69.77 43.51a1.252 1.252 0 0 1 .13 2.5H50.07a1.25 1.25 0 0 1-.13-2.49h19.83Z"
          className="icon-fill icon-accent"/>
      </svg>

    );
  }
}

Icon.displayName = 'PersonWithPlusCircleIcon';

export default Icon;
